import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "team-resort" }
const _hoisted_2 = {
  class: "button button--mobile-no-full-width",
  type: "button"
}
const _hoisted_3 = { class: "button__text" }
const _hoisted_4 = {
  key: 0,
  class: "team-resort__presenter-container"
}
const _hoisted_5 = { class: "team-resort__presenter" }
const _hoisted_6 = { class: "team-resort__selector" }

import { customError, customLog } from '../../../../../../javascripts/utils/log';
import TeamPresenter from '../../../../../organisms/team/views/__team-presenter/vue/team-presenter.vue';
import TeamSelector from '../../../../../molecules/team-selector/vue/team-selector.vue';
import PersonBubble from '../../../../../atoms/person-bubble/vue/person-bubble.vue';
import ResortBubble from '../../../../../molecules/resort-bubble/vue/resort-bubble.vue';
import { computed, onMounted, ref } from 'vue';


export default {
  __name: 'team-resort-view',
  props: {
  backButtonText: {
    type: String,
    required: true,
    validator: (value) => value.length > 0,
  },
  selectedResort: {
    type: Object,
    required: true,
  },
  relatedPersons: {
    type: Array,
    required: true,
  },
  teamSelector: {
    type: Object,
    required: true,
  },
},
  emits: {
  clickedBackButton: () => {
    customLog('[TeamResortView]: clickedBackButton event emitted');
    return true;
  },
  updateSelectedResort: (id) => {
    if (id) {
      customLog(`[TeamResortView]: updateSelectedResort event emitted with id ${id}`);
      return true;
    } else {
      customError('[TeamResortView]: updateSelectedResort event must have an id');
      return false;
    }
  },
  updateSelectedPerson: (id) => {
    if (id) {
      customLog(`[TeamResortView]: updateSelectedPerson event emitted with id ${id}`);
      return true;
    } else {
      customError('[TeamResortView]: updateSelectedPerson event must have an id');
      return false;
    }
  },
},
  setup(__props, { emit: __emit }) {

const props = __props;


const emit = __emit;

const handleBackButtonClick = () => {
  customLog('[TeamResortView]: clicked back button');
  emit('clickedBackButton');
}

const handleInnerComponentClicked = (id) => {
  customLog(`[TeamResortView]: innerComponentClicked event received with id ${id}`);
  // do nothing
  customLog('[TeamResortView]: innerComponentClicked event ignored');
}

const handleOuterComponentClicked = (id) => {
  customLog(`[TeamResortView]: outerComponentClicked event received with id ${id}`);
  emit('updateSelectedPerson', id);
}

const resortBubbleProps = computed(() => ({
  blockHover: true,
  showMemberIndicator: false,
  resortId: props.selectedResort.id,
  resortName: props.selectedResort.name,
  resortMemberCount: props.selectedResort.memberCount,
  resortInfoText: props.selectedResort.description,
}));

const personBubblesProps = computed(() => props.relatedPersons.map((person) => ({
  personId: person.id,
  personImage: {
    src: person.image.thumbnail,
    alt: person.image.alt,
    height: 70,
    width: 70,
  }
})));

// transition
const showPresenter = ref(false);

onMounted(() => {
  customLog('[TeamResortView]: onMounted hook');
  showPresenter.value = true;
});

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "team-resort__back-button",
      onClick: handleBackButtonClick
    }, [
      _createElementVNode("button", _hoisted_2, [
        _cache[2] || (_cache[2] = _createElementVNode("svg", {
          class: "icon icon--play button__icon",
          viewBox: "0 0 200 200",
          "aria-hidden": "true"
        }, [
          _createElementVNode("use", { "xlink:href": "#icon-arrow-left" })
        ], -1)),
        _createElementVNode("span", _hoisted_3, _toDisplayString(__props.backButtonText), 1)
      ])
    ]),
    (resortBubbleProps.value && personBubblesProps.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_Transition, { name: "presenter-fade" }, {
              default: _withCtx(() => [
                (showPresenter.value)
                  ? (_openBlock(), _createBlock(TeamPresenter, {
                      key: 0,
                      "inner-component": ResortBubble,
                      "inner-component-props": resortBubbleProps.value,
                      "outer-component": PersonBubble,
                      "outer-components-props": personBubblesProps.value,
                      onInnerComponentClicked: handleInnerComponentClicked,
                      onOuterComponentClicked: handleOuterComponentClicked,
                      "inner-component-click-event-name": "resortBubbleClicked",
                      "outer-component-click-event-name": "personBubbleClicked"
                    }, null, 8, ["inner-component-props", "outer-components-props"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(TeamSelector, {
        "has-full-width": true,
        "initial-resort-id": __props.selectedResort.id,
        message: __props.teamSelector.message,
        "default-option-resort": __props.teamSelector.defaultOptionResort,
        "default-option-person": __props.teamSelector.defaultOptionPerson,
        resorts: __props.teamSelector.resorts,
        persons: __props.teamSelector.persons,
        onUpdateSelectedResort: _cache[0] || (_cache[0] = $event => (_ctx.$emit('updateSelectedResort', $event))),
        onUpdateSelectedPerson: _cache[1] || (_cache[1] = $event => (_ctx.$emit('updateSelectedPerson', $event)))
      }, null, 8, ["initial-resort-id", "message", "default-option-resort", "default-option-person", "resorts", "persons"])
    ])
  ]))
}
}

}